/* eslint-disable @atlassian/relay/unused-fields */
import React, { memo, useMemo } from 'react';
import { cssMap } from '@compiled/react';
import { graphql, useFragment } from 'react-relay';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import type { WatchersCell$key } from '@atlassian/jira-relay/src/__generated__/WatchersCell.graphql';

export type Props = {
	fieldRef: WatchersCell$key;
};

const styles = cssMap({
	watchesCell: {
		maxWidth: '100%',
		paddingBlock: token('space.050'),
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
});

export const WatchersCell = memo<Props>(({ fieldRef }: Props) => {
	const data = useFragment<WatchersCell$key>(
		graphql`
			fragment WatchersCell on JiraWatchesField {
				watch {
					count
					# isWatching value used in the BulkOpsConnectionsSubscriber to update the WatchersCell after a bulk watch or unwatch action
					isWatching
				}
				__typename
			}
		`,
		fieldRef,
	);

	const countValue = useMemo((): number | null | undefined => {
		return data?.watch?.count;
	}, [data?.watch]);
	return <Box xcss={styles.watchesCell}>{countValue}</Box>;
});
